export default "__VITE_ASSET__CSzUer$y__"